<template>
  <v-menu
    bottom
    offset-y
    offset-x
    :close-on-content-click="false"
    :nudge-width="300"
    v-model="open"
    transition="scale-transition"
    origin="right top"
  >
    <!--BUTTON TO OPEN -->
    <v-btn icon large slot="activator">
      <v-badge color="red" overlap>
        <span slot="badge" small>{{!!totalUnread ? totalUnread : items.length}}</span>
        <v-icon color="grey lighten-2">notifications</v-icon>
      </v-badge>
    </v-btn>

    <v-card color="grey lighten-2">
      <v-list>
        <v-list-tile>
          <v-list-tile-action>
            <v-btn flat icon color="grey" @click="closeNotifs()">
              <v-icon>settings</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="font-weight-bold">Notifications</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn flat color="grey" icon @click="closeNotifs()">
              <v-icon>aspect_ratio</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-divider></v-divider>
      <!-- NOTIFICATIONS LIST-->
      <v-list v-if="!!items.length">
        <notification
          v-for="(item, i) in items"
          :key="i"
          :item="item"
          @click="null"
          @close="closeNotifs()"
        ></notification>
      </v-list>
      <div class="text-xs-center grey--text body-2" v-else>No Notifications to display</div>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn flat @click="closeNotifs()">Ok</v-btn>
        <!-- <v-btn color="primary" flat @click="closeNotifs()">Save</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import Api from "@/services/api";
import Store from "@/store/computed/storeHelpers";
import Notification from "@/components/misc/notification.vue";
export default {
  data() {
    return {
      open: false,
      amount: 5,
      offset: 0,
      items: [],
      totalUnread: null
    };
  },
  methods: {
    getNotifs() {
      Api.get(`notifications/${this.amount}/${this.offset}`)
        .then(result => {
          this.items = result.data.result.notifs;
          this.totalUnread = result.data.result.totalUnread;
        })
        .catch(err => {
          console.log(err);
        });
    },
    closeNotifs() {
      this.open = false;
    }
  },
  components: {
    Notification
  },
  mounted() {
    this.getNotifs();
  }
};
</script>

<style>
</style>
